export default __webpack_public_path__ + "img/allergy-fish.49b76c3d131bc665ea6b55bba7d8a7a2.svg";